<script>
import { ROLE } from '@utils/constant'
import ModalNotificationDetail from '@components/molecules/modal-notification-detail.vue'
import {
  notificationHeaderComputed,
  notificationHeaderMethods,
} from '@state/helpers/notification-header'
import cloneDeep from 'lodash/cloneDeep'
const AGENT_ROLE = [ROLE.AGENT_ADMIN, ROLE.AGENT_SUB, ROLE.AGENT_AUDIT]
export default {
  components: {
    ModalNotificationDetail,
  },
  data: () => {
    return {
      userAgent: [
        {
          label: 'Myアカウント',
          to: '/panel/admin-list-agentadmin/edit',
          icon: '',
        },
        {
          label: 'Myアライアンス',
          to: '/panel/agent-list/edit',
          icon: '',
          roles: [...AGENT_ROLE, ROLE.AGENT_ANNOUNCE],
        },
        {
          label: '操作履歴',
          to: '/panel/log',
          icon: '',
          roles: [...AGENT_ROLE, ROLE.SUPER],
        },
        {
          label: '管理画面設定',
          to: '/panel/setting',
          icon: '',
          roles: [...AGENT_ROLE],
        },
        {
          label: 'ログアウト',
          to: '/panel/logout',
          icon: '',
        },
      ],
      openModal: false,
    }
  },
  computed: {
    ...notificationHeaderComputed,
    show() {
      return !this.$store.state.common.sidebarShow
    },
    currentUserAgent() {
      const role = this.$store.getters['auth/getCurrentUser']
      return this.userAgent.filter((item) => {
        return !item.roles || item.roles.includes(role?.level)
      })
    },

    computedDropdownUserAgent() {
      return this.currentUserAgent
    },
    userName() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.admin_display_name
    },
    notificationListComputed() {
      const list = cloneDeep(this.getShowList?.list)?.map((item) => {
        if (item.image_url) {
          item.image_url =
            process.env.VUE_APP_API_BASE_URL + '/' + item.image_url
        }
        return item
      })
      return list
    },
    notificationDetailComputed() {
      return this.getNotificationDetails || {}
    },
    urlImageComputed() {
      if (this.getShowList?.image_url) {
        return `${process.env.VUE_APP_API_BASE_URL}/${this.getShowList.image_url}`
      }
      return ''
    },
    unReadMessageCount() {
      const unRead = this.getShowList?.list?.filter((item) => !item.read)
      if (unRead?.length > 99) {
        return '99+'
      }
      return unRead?.length || ''
    },
  },
  watch: {},
  mounted() {
    this.fetchingShowList()
  },
  methods: {
    ...notificationHeaderMethods,
    async getModalDetail(id) {
      this.openModal = true
      const response = await this.fetchingNotificationDetails({ id })
      if (response) {
        this.fetchingShowList()
      }
    },
    closeModalDetail() {
      this.openModal = false
      event.stopPropagation()
    },
  },
}
</script>

<template>
  <div class="sticky-top">
    <CHeader with-subheader light>
      <CToggler
        in-header
        class="ml-3 d-lg-none"
        @click="$store.commit('common/TOGGLE_SIDEBAR_MOBILE')"
      />
      <CToggler
        in-header
        class="ml-3 d-md-down-none"
        @click="$store.commit('common/TOGGLE_SIDEBAR_DESKTOP')"
      />
      <CHeaderBrand v-show="show" to="/">
        <CIcon
          name="logo"
          alt="Logo"
          size="custom-size"
          :height="35"
          view-box="0 0 662 200"
        />
      </CHeaderBrand>
      <CHeaderNav class="ml-auto mr-0">
        <BaseNavDropDown
          :items="computedDropdownUserAgent"
          text-header="アカウントメニュー"
          :text-toggle="userName"
        />
        <BaseNavDropDown
          :items="notificationListComputed"
          text-toggle="お知らせ"
          text-header="お知らせ一覧"
          :count-notification="unReadMessageCount"
        >
          <template v-slot:prepend-icon>
            <font-awesome-icon icon="bell" />
          </template>
          <template v-slot:prepend-item="{ item }">
            <div
              class="d-flex notification-item"
              @click="getModalDetail(item.id)"
            >
              <div v-if="!item.read" class="notification-unread"></div>
              <div
                class="w-25 d-flex align-items-center justify-content-center nofification-img"
              >
                <CImg v-show="item.image_url" :src="item.image_url" />
              </div>
              <div
                v-if="!item.read"
                class="w-75 d-flex flex-column nofification-text p-1 font-weight-bold"
              >
                <span>{{ item.start }}</span>
                <span class="notification-title">{{ item.title }}</span>
              </div>
              <div v-else class="w-75 d-flex flex-column nofification-text p-1">
                <span>{{ item.start }}</span>
                <span class="notification-title">{{ item.title }}</span>
              </div>
            </div>
          </template>
        </BaseNavDropDown>
      </CHeaderNav>
      <CSubheader class="px-3 shadow-sm">
        <BaseBreadcrumbRouter class="border-0 mb-0" />
      </CSubheader> </CHeader
    ><ModalNotificationDetail
      :show.sync="openModal"
      :item="notificationDetailComputed"
      @closeModal="closeModalDetail"
    />
  </div>
</template>

<style lang="scss" scoped>
.notification-item {
  position: relative;
  width: 300px;
  margin-right: 0;

  &:hover {
    background-color: $bg-notification-header-hover;
  }
  &:active {
    background-color: map-get($map: $theme-colors, $key: 'primary');
  }

  ::v-deep .nofification-img {
    border-right: 1px solid #c8ced3;
  }

  img {
    max-width: 67px;
    max-height: 50px;
    object-fit: cover;
  }
  .notification-title {
    max-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
  }
  .notification-unread {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 999999;
    width: 10px;
    height: 10px;
    background-color: map-get($map: $theme-colors, $key: 'primary');
    border-radius: 50%;
  }
}
::v-deep #base-nav-drop-down {
  margin: 0 0 0 10;
}
::v-deep .notification-list {
  max-height: 520px;
  overflow-y: auto;
}
</style>
